import { collection, getDocs, query, orderBy, doc, getDoc } from 'firebase/firestore';
import { db } from '../../../../firebase/config';

export type SelectedItem = {
    itemId: string;
    itemCode: string;
    itemName: string;
    quantity: number;
};

export type CCTVRequest = {
    id: string;
    requestId?: string;
    dateOfRequest?: string;
    branchCode?: string;
    branchName?: string;
    branchId?: string;
    vendor?: string;
    vendorId?: string;
    items?: SelectedItem[];
    remarks?: string;
    status?: string;
    cancelReason?: string;
    cancelledAt?: any;
    cancelledBy?: string;
    createdAt?: any;
    updatedAt?: any;
    createdBy?: string;
    requestType?: string;
    [key: string]: any;
};

/**
 * Fetch company ID for the current user (PSO or Bank user)
 */
export async function fetchCompanyId(uid: string, isBankUser: boolean = false): Promise<string | null> {
    try {
        if (isBankUser) {
            // For bank users, check if uid is a bank document ID or if there's a bank with userId == uid
            const directBank = await getDoc(doc(db, "banks", uid));
            if (directBank.exists()) {
                return uid;
            }
            // Try query by userId field
            const banksSnap = await getDocs(collection(db, "banks"));
            for (const bankDoc of banksSnap.docs) {
                const bankData = bankDoc.data();
                if (bankData.userId === uid) {
                    return bankDoc.id;
                }
            }
            return null;
        } else {
            // For PSO users, find which bank has this PSO
            const banksSnap = await getDocs(collection(db, 'banks'));
            for (const bankDoc of banksSnap.docs) {
                const posDocRef = doc(db, 'banks', bankDoc.id, 'pos', uid);
                const posDoc = await getDoc(posDocRef);
                if (posDoc.exists()) {
                    return bankDoc.id;
                }
            }
            return null;
        }
    } catch (error) {
        console.error('Error fetching company ID:', error);
        return null;
    }
}

/**
 * Fetch all CCTV requests for a company
 */
export async function fetchCCTVRequests(companyId: string): Promise<CCTVRequest[]> {
    if (!companyId) {
        return [];
    }

    try {
        const requestsSnap = await getDocs(
            query(
                collection(db, 'banks', companyId, 'hardware_requests'),
                orderBy('createdAt', 'desc')
            )
        );

        const requestsList = requestsSnap.docs
            .map(doc => ({
                id: doc.id,
                ...doc.data()
            }))
            .filter((request: any) => request.requestType === 'CCTV') as CCTVRequest[];

        return requestsList;
    } catch (error) {
        console.error('Error fetching CCTV requests:', error);
        throw error;
    }
}

